<template>
  <div class="menu-option-wrapper pure-u-1-1" v-touch:tap="categoryItemClicked">

    <router-link v-if="isbutton" :to="{ path: values.link, props: { caseref: values }}" class="router-link-active">
      <div class="menu-option isbutton pure-g">
        <div class="menu-icon pure-u-1-5">
          <div :class="['option-icon', getIconClass]"></div>
        </div>
        <div :class="['text', 'center', {'pure-u-3-5': hasCheck, 'pure-u-4-5': !hasCheck}]">
          <p>{{ values.text }}</p>
        </div>
        <div class="check pure-u-1-5" v-if="hasCheck">
          <div :class="['checkbox', {'checked': values.checked}]"></div>
        </div>
      </div>
    </router-link>
    <div v-else-if="!isbutton" class="menu-option pure-g">
      <div class="menu-icon pure-u-1-5">
        <div :class="['option-icon', getIconClass]"></div>
      </div>
      <div class="text center pure-u-3-5">
        <p>{{ values.text }}</p>
      </div>
      <div class="check pure-u-1-5" v-if="hasCheck">
        <div :class="['checkbox', {'checked': values.checked}]"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import dataValues from '../../assets/data/context.json'

  export default {
    name: 'menu-option',
    data () {
      return {
        iconName: this.values.icon,
        hasCheck: false,
        dataContext: dataValues
      }
    },
    computed: {
      getIconClass () {
        return this.iconName
      },
      hasContext () {
        return this.values.context !== undefined && this.values.context !== ''
      }
    },
    watch: {
      iconName: function () {
        this.iconName = this.values.icon
      }
    },
    beforeMount () {
      this.hasCheck = (this.values.checked !== undefined)
    },
    props: {
      values: {
        type: Object,
        required: true,
        icon: {
          type: String,
          default: ''
        }
      },
      context: {
        type: String,
        default: ''
      },
      isbutton: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      categoryItemClicked () {
        if (this.values.context !== undefined && this.values.context !== '') {
          this.store.setItem(this.dataContext.current_context, this.values.context)
          if (!this.store.getItemOrFalse(this.dataContext.current_progress)) {
            let obj = {}
            for (let i = 0; i < this.dataContext.categories.length; i++) {
              obj[this.dataContext.categories[i].cat] = []
            }
            this.store.createIfNotExisting(this.dataContext.current_progress, obj)
          }
        }
        this.$bus.$emit('MENU-OPTION-CLICKED', {context: this.values.context})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/menu-options/index.vue